import { Multiselect, Select } from 'AWS-UI-Components-React';
import React from 'react';
import { padZero } from '../../utils/date-utils';
import { Asterisk } from './asterisk';

export class TimeFrameButton extends React.Component {

  getDropdownOptions = (yearQuarter = true, reverse = false, exclude = null) => {
      let options = [];
      let currentDate = new Date(this.props.startMonth/100, this.props.startMonth%100 - 1);
      let endDate = new Date(this.props.endMonth/100, this.props.endMonth%100 - 1);
      while(currentDate.getTime() <= endDate.getTime()){
          let year = currentDate.getFullYear();
          let month = currentDate.getMonth() + 1;
          options.unshift({
              'label': currentDate.toLocaleString('default', {month: 'short'}) + ' ' + year,
              'id': `${year}/${padZero(month)}`,
          });
          if((month % 3 === 0 || currentDate.getTime() === endDate.getTime()) && yearQuarter){
              options.unshift({
                  'label': `Q${Math.ceil(month/3)} ${year}`,
                  'id': `${year}Q${Math.ceil(month/3)}`
              })
          }
          if((month === 12 || currentDate.getTime() === endDate.getTime()) && yearQuarter){
              options.unshift({
                  'label': `${year}`,
                  'id': `${year}`,
              });
          }
          currentDate.setMonth(month);
      }
    options = exclude ? options.filter(opt => !exclude.some(e => e === opt.id)) : options;
    return reverse? options.reverse() : options;
  };

  render() {
    if(this.props.multiSelect){
        return (
            <div>
                <b> {this.props.text} </b>
                <Asterisk required={this.props.required}/>
                <Multiselect
                className={'TreeMultiSelect'}
                options={this.getDropdownOptions(this.props.hasOwnProperty('yearQuarter') ? this.props.yearQuarter: true,
                                                 this.props.hasOwnProperty('reverse') ? this.props.reverse : false,
                                                 this.props.exclude)}
                placeholder={this.props.hasOwnProperty('placeholder')? this.props.placeholder : this.props.text}
                onChange={this.props.onChange}
                selectedIds={this.props.selected}
                checkboxes={true}
                data-cy={this.props['data-cy']}
                />
            </div>
        );
    }else{
        return (
          <div>
              <b> {this.props.text} </b>
              <Asterisk required={this.props.required}/>
              <Select
                options={this.getDropdownOptions(this.props.multiSelect, this.props.reverse? this.props.reverse : false)}
                placeholder={this.props.hasOwnProperty('placeholder')? this.props.placeholder : this.props.text}
                onChange={this.props.onChange}
                selectedId={this.props.selected}
                data-cy={this.props['data-cy']}
              />
          </div>
        )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/time_frame_button.jsx